import { Paper, Typography } from "@mui/material";
import { useEffect } from "react";
import {
  usePushConnectorRouteParamListener,
  useSelectedPushConnector,
} from "../../../hook/pushConnector";
import { usePushConnectorForm } from "../../../hook/pushConnector/edit";
import { PushConnectorFormField } from "../../../types/pushConnector";
import { PushConnectorFormFields } from "./components";

export const PushConnectorViewPage: React.FC = () => {
  usePushConnectorRouteParamListener();
  const [selectedPushConnector, setSelectedPushConnector] =
    useSelectedPushConnector();
  const [pushConnectorForm, setPushConnectorForm] = usePushConnectorForm();
  const selectedPushConnectorId = selectedPushConnector?.id;
  useEffect(() => {
    const pushConnectorForm: PushConnectorFormField[] = Object.entries(
      selectedPushConnector?.data ?? []
    ).map(([label, value]) => ({
      label,
      value,
    }));
    setPushConnectorForm(pushConnectorForm);
  }, [selectedPushConnectorId]);

  return (
    <Paper
      sx={{ padding: 3, gap: 3, display: "flex", flexDirection: "column" }}
    >
      {selectedPushConnector ? (
        <>
          <Typography variant="h3">{selectedPushConnector.name}</Typography>
          <PushConnectorFormFields
            pushConnectorForm={pushConnectorForm}
            disabled={true}
          />
        </>
      ) : (
        <Typography>Loading</Typography>
      )}
    </Paper>
  );
};
